import React, {useEffect, useState} from 'react'
import Modal from '../Modal'
import NewModal from '../NewModal/NewModal'
import Form from '../Form/Form'
import FormInput from '../Inputs/FormInput/FormInput'
import {useForm} from 'react-hook-form'
import ApiSearchInput from './APISearchInput'
import {observer} from 'mobx-react'
import ModalsStore from '../Pages/Modals.store'
import AttentionGenerator from '../Form/AttentionGenerator'
import styled from "styled-components";
import CheckboxInput from "../Inputs/CheckboxInput/CheckboxInput";
import RadioInput from "../Inputs/RadioInput/RadioInput";



const QuizRentgenModal = observer(() => {
    const NAME = `QuizRentgenModal`
    const {data, methods} = ModalsStore.Modals[NAME]
    const [status, setStatus] = useState()
    const [error, setError] = useState({})
    const [prediagnos, setPrediagnos] = useState(data.initialForm.prediagnos)
    const [sentby, setSentby] = useState(data.initialForm.sentby)
    const [anamnes, setAnamnes] = useState(data.initialForm.anamnes)
    const [rdoza, setRdoza] = useState(data.initialForm.rdoza)
    const [rtype, setRtype] = useState('')
	
	// alert(JSON.stringify(data.studyTypesData));
	

    const {errors, setValue, watch, register, handleSubmit} = useForm(
        {defaultValues: data.initialForm})

	const typeVariants = data.studyTypesData;
	/*[
		"Рентгенография всего черепа, в одной или более проекциях",
		"Рентгенография шейного отдела позвоночника",
		"Рентгенография шейно-дорсального отдела позвоночника",
		"Рентгенография грудного отдела позвоночника",
		"Рентгенография грудного и поясничного отдела позвоночника",
		"Рентгенография поясничного отдела позвоночника",
		"Рентгенография поясничного и крестцового отдела позвоночника",
		"Рентгенография крестца и копчика",
		"Рентгенография крестца",
		"Рентгенография копчика",
		"Рентгенография позвоночника с функциональными пробами",
		"Рентгенография верхней конечности",
		"Рентгенография ключицы",
		"Рентгенография ребер",
		"Рентгенография грудины",
		"Рентгенография лопатки",
		"Рентгенография головки плечевой кости",
		"Рентгенография плечевой кости",
		"Рентгенография локтевой кости и лучевой кости",
		"Рентгенография запястья",
		"Рентгенография пясти",
		"Рентгенография кисти",
		"Рентгенография фаланг пальцев кисти",
		"Рентгенография пальцев фаланговых костей кисти",
		"Рентгенография I пальца кисти",
		"Рентгенография нижней конечности",
		"Рентгенография подвздошной кости",
		"Рентгенография седалищной кости",
		"Рентгенография лонного сочленения",
		"Рентгенография таза",
		"Рентгенография головки и шейки бедренной кости",
		"Рентгенография бедренной кости",
		"Рентгенография диафиза бедренной кости",
		"Рентгенография надколенника",
		"Рентгенография большой берцовой и малой берцовой костей",
		"Рентгенография диафиза большой берцовой и малой берцовой костей",
		"Рентгенография лодыжки",
		"Рентгенография предплюсны",
		"Рентгенография пяточной кости",
		"Рентгенография плюсны и фаланг пальцев стопы",
		"Рентгенография стопы в одной проекции",
		"Рентгенография стопы в двух проекциях",
		"Рентгенография стопы с функциональной нагрузкой",
		"Рентгенография фаланг пальцев ноги",
		"Рентгенография I пальца стопы в одной проекции",
		"Рентгенография пораженной части костного скелета",
		"Рентгенография черепа в прямой проекции",
		"Рентгенография локтевого сустава",
		"Рентгенография лучезапястного сустава",
		"Рентгенография коленного сустава",
		"Рентгенография плечевого сустава",
		"Рентгенография тазобедренного сустава",
		"Рентгенография голеностопного сустава",
		"Рентгенография акромиально-ключичного сочленения",
		"Рентгенография грудино-ключичного сочленения",
		"Рентгенография придаточных пазух носа",
		"Рентгенография лобной пазухи",
		"Рентгенография гайморовых пазух",
		"Рентгенография органов грудной клетки прицельная",
		"Рентгенография легких цифровая",
		"Рентгенография мочевыделительной системы (Обзорная урография)",
		"Флюорография",
		"GGG"
	]*/

    return (
        <Modal mobile={true}>
            <NewModal
                completed={status}
                completedText={'Сохранено!'}
                completedButtonText={'Продолжить'}
                title={'Анкета рентген'}
                closeHandler={_ => ModalsStore.closeModal(NAME)}
				style={{width: '90%', height:'90%',maxHeight:'100%'}}
				hideErrors={true}
				containerStyle={{width: '90%', height:'100%',maxHeight:'100%'}}
            >

                <Form submitHandler={handleSubmit(async (formData) => {
                    await methods.submit({...formData, 
							prediagnos, sentby,anamnes,rdoza,rtype,
						}) // 
                        .then(response => response !== 'success'
                            ? setError({
                                type: 'def',
                                message: 'Ой. У нас что-то пошло не так. Повторите свою попытку позже.'
                            })
                            : setStatus(true))

                })} submitDisabled={rtype==''} submitButtonText={'Сохранить'}>
					<div style={{flex:1,flexDirection:'column',display: 'flex',}}>
						<p style={{marginTop: '15px'}}>Обследование</p>
						<select onChange={(event) => {setRtype(event.target.value)}} value={rtype}>
							<option value={''} key={'gg'}>Выберите</option>
							{typeVariants.map((v)=>{
								return <option value={v} key={v}>{v}</option>;
							})}
						</select>
						<p style={{marginTop: '15px'}}>Предварительный диагноз</p>
						<textarea value={prediagnos} onChange={(event) => {setPrediagnos(event.target.value)}} 
							style={{width:'100%',height:'120px'}}/>
						<p style={{marginTop: '15px'}}>Кто направил</p>
						<textarea value={sentby} onChange={(event) => {setSentby(event.target.value)}} 
							style={{width:'100%',height:'120px'}}/>
						<p style={{marginTop: '15px'}}>Анамнез</p>
						<textarea value={anamnes} onChange={(event) => {setAnamnes(event.target.value)}} 
							style={{width:'100%',height:'120px'}}/>
						<p style={{marginTop: '15px'}}>Доза ЭЭД, млЗв</p>
						<input value={rdoza} onChange={(event) => {setRdoza(event.target.value)}} 
							style={{width:'100%'}}/>

					</div>
                </Form>
            </NewModal>
        </Modal>
    )
})
const StyledAttention = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 12px;
`

export default QuizRentgenModal
